import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-4 pt-5" }
const _hoisted_2 = {
  key: 0,
  class: "relative min-h-300"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col gap-4"
}
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl" }, "Current Plan", -1)
const _hoisted_6 = { class: "flex gap-8 items-center mb-3" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "font-medium" }

import {
	UiCard,
	UiLoader,
	UiButton,
	SvgIcon,
	UiRadioTabs
} from '@/ui-kit';
import { useBilling } from '../composition';
import { useToggle } from '@vueuse/core';
import SubscriptionBalance from './SubscriptionBalance.vue';
import SubscriptionTitle from './SubscriptionTitle.vue';
import SubscriptionProducts from './SubscriptionProducts.vue';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import { useCompanyProfile } from '@/account';
import { StripeInvoice } from '../composition/subscription-v2-state';
import Invoice from '../components/Invoice.vue';

declare const rewardful: any;


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrentSubscription',
  setup(__props) {

const [isPortalLoading, setIsPortalLoading] = useToggle();
const {
	isLoaded,
	loadPortalLink,
	hasSubscription,
	currentSubscription,
	getRenewalDate,
	isSubscriptionIncomplete
} = useBilling();
const { userProfile } = useCompanyProfile();

const route = useRoute();
const router = useRouter();
const { success, info } = useToast();

if (route.query.success) {
	success('Purchase was successfully completed.');
	if (typeof rewardful !== 'undefined') {
		rewardful('convert', {
			email: userProfile.value?.email
		});
	}
	router.replace(route.path);
}

if (route.query.cancel) {
	info('Purchase was canceled.');
	router.replace(route.path);
}

async function openPortal() {
	setIsPortalLoading(true);
	const link = await loadPortalLink();
	window.open(link, '_blank');
	setIsPortalLoading(false);
}

function sortInvoices(
	invoices: StripeInvoice[]
): StripeInvoice[] {
	return invoices
		.slice()
		.sort(
			(left, right) =>
				new Date(right.created_at).getTime() -
				new Date(left.created_at).getTime()
		);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isLoaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(UiLoader), {
            wrapperClass: "base text-reverse",
            loadingText: "Loading billing details..."
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_unref(hasSubscription))
              ? (_openBlock(), _createBlock(_unref(UiButton), {
                  key: 0,
                  class: "!text-sm !h-10",
                  theme: "primary-outlined",
                  loading: _unref(isPortalLoading),
                  onClick: openPortal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Go to billing portal "),
                    _createVNode(_unref(SvgIcon), {
                      class: "ml-2 h-5 w-5",
                      name: "external-link"
                    })
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(UiCard), { theme: "white" }, {
            default: _withCtx(() => [
              _createVNode(SubscriptionBalance)
            ]),
            _: 1
          }),
          (_unref(currentSubscription))
            ? (_openBlock(), _createBlock(_unref(UiCard), {
                key: 0,
                theme: "white"
              }, {
                default: _withCtx(() => [
                  _createVNode(SubscriptionTitle)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(SubscriptionProducts),
          (
					_unref(currentSubscription)?.upcomingInvoice ||
					_unref(currentSubscription)?.invoices.length
				)
            ? (_openBlock(), _createBlock(_unref(UiCard), {
                key: 1,
                theme: "white",
                title: "Invoices"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getRenewalDate)(
							_unref(currentSubscription)?.created_at
						)), 1),
                    _createElementVNode("div", _hoisted_8, " $" + _toDisplayString(Number(
								_unref(currentSubscription)
									?.upcomingInvoice.total
							).toFixed(2)), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass([
							'text-xs font-bold px-1 py-0.5 text-white rounded-md capitalize bg-blue-500'
						])
                    }, " Upcoming ", 2)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortInvoices(
						_unref(currentSubscription)?.invoices || []
					), (invoice) => {
                    return (_openBlock(), _createBlock(Invoice, {
                      class: "mb-3",
                      key: invoice.invoiceNumber,
                      invoice: invoice
                    }, null, 8, ["invoice"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})